<!-- fixed-scroll-table.component.html -->
<div class="table-container" style="font-size: xx-small">
    <!-- Header Section -->
    <div class="table-header" *ngIf="FromDate != null && ToDate != null">
        <!-- Left Fixed Header -->
        <div class="left-section" style="width: max-content;">
            <div class="left-header-cell" style="min-width:235px;max-width:235px;font-size: larger;">EMPLOYEE DETAILS
            </div>
            <!-- <div class="left-header-cell">DES</div>
            <div class="left-header-cell">DUTY</div>
            <div class="left-header-cell">SHIFT</div> -->
        </div>

        <!-- Scrollable Center Header -->
        <div style="display: grid;width: -webkit-fill-available;">
            <div style="display: flex; justify-content: space-between;font-size:small" class="text-primary px-2">
                <span class="cursor-pointer" (click)="leftrightClick(true)"><i class="bi bi-chevron-left"></i>
                    Left</span>

                <span class="text-muted" style="text-align-last: center; font-size: x-small;">Attendance Cycle <br />
                    {{FromDate}} To {{ToDate}}
                </span>
                <span class="cursor-pointer" (click)="leftrightClick(false)">Right <i
                        class="bi bi-chevron-right"></i></span>
            </div>
            <div class="scrollable-header center-section" (scroll)="onScroll($event)" #centerScroll>
                <div class="day-cell" style="height: 31px;" *ngFor="let day of dateKeys">
                    {{ GetDays(day) }} <small class="d-block">{{getDayAbbreviation(day)}}</small>
                </div>
            </div>
        </div>

        <!-- Right Fixed Header -->
        <div class="right-section" style="width: max-content;"
            [ngStyle]="{ 'margin-right':this.hasVerticalScroll?'10px':'0px'}">
            <div class="header-cell">P</div>
            <div class="header-cell">A</div>
            <div class="header-cell">CO</div>
            <div class="header-cell">WO</div>
            <div class="header-cell">H</div>
            <!-- <div class="header-cell header-cell-exbig">Total Leave</div> -->
            <div class="header-cell">CL</div>
            <div class="header-cell">SL</div>
            <div class="header-cell">PL</div>
            <div class="header-cell header-cell-big">CALDAY</div>
            <div class="header-cell header-cell-big">WORK</div>
            <div class="header-cell">OT</div>
            <div class="header-cell">RT</div>
            <div class="header-cell header-cell-big">Action</div>
        </div>
    </div>

    <!-- Data Rows -->
    <div #myDiv class="table-body">
        <div class="table-row" *ngFor="let employee of tableData; let last = last;let i = index"
            style="min-height:4rem">
            <!-- Left Fixed Data -->
            <div class="left-section" style="width: max-content;">
                <div class="left-header-cell" style="min-width:235px;max-width:235px"
                    [ngClass]="isAttendanceErrorHighlight(employee)">
                    <div class="row no-gutters cursor-pointer text-start align-items-center px-2">
                        <div class="col-3">
                            <img *ngIf="employee.Photo" mat-card-image class="userImage"
                                [src]="this.common.PhotoLink(employee.Photo,false)" style="width: 30px;height: 30px;" />

                            <div *ngIf="!employee.Photo" class="initial-image" data-is-profile="true"
                                style="width: 30px;height: 30px;">
                                <div class="image" style="line-height:30px">
                                    {{this.common.getInitial(employee.FullName)}}
                                </div>
                            </div>
                        </div>
                        <div class="col userdetail p-0">
                            <span class="text-label" style="font-size: xx-small !important;">{{i+1}}.
                                {{employee.FullName}}</span><br />
                            <span class="text-label-light" style="font-size: xx-small !important;">#{{employee.EmpCode}}
                                / {{employee.Gender}}</span>
                        </div>
                        <div class="col-auto">
                            <i class="bi bi-info-circle-fill p-2 tooltipi custom-tooltip" style="font-size: small;"
                                placement="right" [ngbTooltip]="tooltipContent"
                                [tooltipContext]="{ data: tableData[i] }">
                            </i>
                        </div>
                    </div>
                    <div class="row p-0 m-0 g-1">
                        <div class="col-6">
                            <span class="text-label"
                                style="font-size: xx-small !important;display: block;background: lightgrey;">
                                <!-- <ng-select class="DDS" name="DesignationId{{i}}" #DesignationId="ngModel"
                                    placeholder="Select Designation" [(ngModel)]="employee.CDesignationMasterId"
                                    (focus)="storePrevious('Designation',employee)"
                                    (change)="handleDesignationDutyChange('Designation',$event, i, employee)"
                                    [clearable]="false" [appendTo]="'body'" required>
                                    <ng-option *ngFor="let Designation of Designations"
                                        title="{{Designation.DesignationName}}"
                                        [value]="Designation.DesignationMasterID">{{Designation.DesignationName}}</ng-option>
                                </ng-select> -->
                                {{employee.DesignationName}}
                            </span>
                        </div>
                        <div class="col-6">
                            <span class="text-label"
                                style="font-size: xx-small !important;display: block;background: lightgrey;">
                                <!-- <ng-select class="DDS" name="DutyMasterID{{i}}" placeholder="Select Duty"
                                    (focus)="storePrevious('Duty',employee)"
                                    (change)="handleDesignationDutyChange('Duty',$event, i, employee)"
                                    [clearable]="false" [(ngModel)]="employee.CDutyMasterId" [clearable]="false"
                                    [appendTo]="'body'" required>
                                    <ng-option *ngFor="let Duty of employee.Dutys" title="{{Duty.DutyName}}"
                                        [value]="Duty.DutyMasterID">{{Duty.DutyName}}</ng-option>
                                </ng-select> -->
                                {{employee.DutyName}}
                            </span>
                        </div>
                        <!-- <div class="col-4">
                            <span class="text-label"
                                style="font-size: xx-small !important;height: 10px;display: block;">
                                <ng-select class="DDS" name="ShiftMasterID{{i}}" placeholder="Select Shift"
                                    [(ngModel)]="employee.CShiftMasterId" [clearable]="false" [appendTo]="'body'"
                                    required>
                                    <ng-option *ngFor="let Shift of employee.Shifts" title="{{Shift.ShiftTitle}}"
                                        [value]="Shift.ShiftMasterID">{{Shift.ShiftTitle}}</ng-option>
                                </ng-select>
                            </span>
                        </div> -->
                    </div>
                </div>
                <!-- <div class="left-header-cell">{{ employee.DesignationName }}</div>
                <div class="left-header-cell">{{ employee.DutyName }}</div>
                <div class="left-header-cell">{{ employee.ShiftTitle }}</div> -->
            </div>

            <!-- Scrollable Center Data -->
            <div class="center-section" #centerScroll (scroll)="onScroll($event)" [style.width.%]="50">
                <div class="scrollable-data">
                    <div class="day-data-cell" tabindex="0" *ngFor="let day of dateKeys"
                        (focus)="onDayFocus('F', day, employee)" (blur)="onDayFocus('B', day, employee)"
                        (keydown)="onDayKeyPress($event, employee, day)" [ngClass]="isAttendanceAllowed(day, employee)">
                        {{employee[day]}}
                    </div>
                </div>
                <!-- @if(last){
                <div class="scrollable-data">
                    <div class="day-data-cell" *ngFor="let day of dateKeys;let i = index">
                        <i class="bi bi-pencil-square text-warning" (click)="Datewise(i)"></i>
                    </div>
                </div>
                } -->
            </div>

            <!-- Right Fixed Data -->
            <div class="right-section" style="width: max-content;">
                <div class="data-cell">{{employee.P}}</div>
                <div class="data-cell">{{employee.A}}</div>
                <div class="data-cell">{{employee.CO}}</div>
                <div class="data-cell">{{employee.WO}}</div>
                <div class="data-cell">{{employee.H}}</div>
                <!-- <div class="data-cell data-cell-exbig">
                    <span>
                        {{employee.TotalLeave}}
                        <i class="bi bi-info-circle-fill p-2 tooltipi custom-tooltip" style="font-size: inherit;"
                            placement="bottom-right" [ngbTooltip]="tooltipContentLeave"
                            [tooltipContext]="{ data: tableData[i] }" container="body" [autoClose]="false"
                            [openDelay]="100" tooltipClass="leavetypstooltip">
                        </i>
                    </span>
                </div> -->
                <div class="data-cell">{{employee.CL}}</div>
                <div class="data-cell">{{employee.SL}}</div>
                <div class="data-cell">{{employee.PL}}</div>
                <div class="data-cell data-cell-big">{{employee['CALC DAYS']}}</div>
                <div class="data-cell data-cell-big">{{employee['WORK DAYS']}}</div>
                <div class="data-cell">{{employee.OT}}</div>
                <div class="data-cell">{{employee.RT}}</div>
                <div class="data-cell data-cell-big g-2">

                    <i class="bi bi-pencil-square editIcon pe-2" (click)="Empwise(i)"></i>
                    <i class="bi bi-trash deleteIcon" *ngIf="!this.IsLocked && this.common.PageRight.IsDelete"
                        (click)="deleteEmp(i)"></i>
                </div>
            </div>
        </div>
    </div>

    <div class="table-header">

        <!-- for last row total and edit -->
        <div class="table-row" *ngIf="tableData.length > 0">
            <!-- Left Fixed Data -->
            <div class="left-section" style="width: max-content;">
                <div class="left-header-cell" style="min-width:235px;max-width:235px">
                </div>
            </div>

            <!-- Scrollable Center Data -->
            <div style="display: grid;width: -webkit-fill-available;">
                <div class="scrollable-header center-section" (scroll)="onScroll($event)" #centerScroll>
                    <div class="day-cell" style="height: 31px;" *ngFor="let day of dateKeys;let i = index">
                        <i class="bi bi-pencil-square editIcon tooltipi" (click)="Datewise(i)"
                            [ngbTooltip]="GetDays(day).toString() + ' ' + getDayAbbreviation(day)"></i>
                    </div>
                </div>
            </div>

            <!-- Right Fixed Data -->
            <div class="right-section" style="width: max-content;"
                [ngStyle]="{ 'padding-right':this.hasVerticalScroll?'10px':'0px'}">
                <div class="data-cell totalCell">{{Totol.P}}</div>
                <div class="data-cell totalCell">{{Totol.A}}</div>
                <div class="data-cell totalCell">{{Totol.CO}}</div>
                <div class="data-cell totalCell">{{Totol.WO}}</div>
                <div class="data-cell totalCell">{{Totol.H}}</div>
                <!-- <div class="data-cell data-cell-exbig totalCell">{{Totol.TotalLeave}}</div> -->
                <div class="data-cell totalCell">{{Totol.CL}}</div>
                <div class="data-cell totalCell">{{Totol.SL}}</div>
                <div class="data-cell totalCell">{{Totol.PL}}</div>
                <div class="data-cell data-cell-big totalCell">{{Totol.CD}}</div>
                <div class="data-cell data-cell-big totalCell">{{Totol.WD}}</div>
                <div class="data-cell totalCell">{{Totol.OT}}</div>
                <div class="data-cell totalCell">{{Totol.RT}}</div>
                <div class="data-cell data-cell-big g-2"></div>
            </div>
        </div>
    </div>
</div>

<ng-template #tooltipContent let-data="data">
    <div style="text-align: -webkit-left;">
        <div><strong>Joining Date:</strong> {{ data.JoiningDate }}</div>
        <div *ngIf="data.LeftDate"><strong>Left Date:</strong> {{ data.LeftDate }}</div>
        <div><strong>Gross Salary:</strong> {{ data.GrossIncome }}</div>
    </div>
</ng-template>


<!-- <ng-template #tooltipContentLeave let-data="data">
    <div class="minimal-leave-tooltip">
        <div class="minimal-header" style="color:white">
            <span>🎯 Leave Balance</span>
        </div>

        <div class="badge-container">
            <div class="leave-badge">
                <span class="badge-label">CL</span>
                <span class="badge-value">{{data.CL || 0}}</span>
            </div>
            <div class="leave-badge">
                <span class="badge-label">SL</span>
                <span class="badge-value">{{data.SL || 0}}</span>
            </div>
            <div class="leave-badge">
                <span class="badge-label">PL</span>
                <span class="badge-value">{{data.PL || 0}}</span>
            </div>
            <div class="leave-badge">
                <span class="badge-label">ML</span>
                <span class="badge-value">{{data.ML || 0}}</span>
            </div>
            <div class="leave-badge">
                <span class="badge-label">PTA</span>
                <span class="badge-value">{{data.PTA || 0}}</span>
            </div>
            <div class="leave-badge">
                <span class="badge-label">BR</span>
                <span class="badge-value">{{data.BR || 0}}</span>
            </div>
            <div class="leave-badge">
                <span class="badge-label">MS</span>
                <span class="badge-value">{{data.MS || 0}}</span>
            </div>
            <div class="leave-badge">
                <span class="badge-label">BL</span>
                <span class="badge-value">{{data.BL || 0}}</span>
            </div>
        </div>
    </div>
</ng-template> -->

<!-- <ng-template #tooltipContentLeave let-data="data">
    <div class="leave-tooltip-content">
        <div class="tooltip-header">
            <h6>Leave Balance Summary</h6>
            <span class="badge">Current Year</span>
        </div>
        
        <div class="leave-grid">
            <div class="leave-card">
                <div class="leave-label">CL</div>
                <div class="leave-value">{{data.CL || 0}}</div>
                <div class="leave-name">Casual Leave</div>
            </div>
            
            <div class="leave-card">
                <div class="leave-label">SL</div>
                <div class="leave-value">{{data.SL || 0}}</div>
                <div class="leave-name">Sick Leave</div>
            </div>
            
            <div class="leave-card">
                <div class="leave-label">PL</div>
                <div class="leave-value">{{data.PL || 0}}</div>
                <div class="leave-name">Privilege Leave</div>
            </div>
            
            <div class="leave-card">
                <div class="leave-label">ML</div>
                <div class="leave-value">{{data.ML || 0}}</div>
                <div class="leave-name">Maternity Leave</div>
            </div>
            
            <div class="leave-card">
                <div class="leave-label">PTA</div>
                <div class="leave-value">{{data.PTA || 0}}</div>
                <div class="leave-name">Personal Time</div>
            </div>
            
            <div class="leave-card">
                <div class="leave-label">BR</div>
                <div class="leave-value">{{data.BR || 0}}</div>
                <div class="leave-name">Bereavement</div>
            </div>
            
            <div class="leave-card">
                <div class="leave-label">MS</div>
                <div class="leave-value">{{data.MS || 0}}</div>
                <div class="leave-name">Medical Special</div>
            </div>
            
            <div class="leave-card">
                <div class="leave-label">BL</div>
                <div class="leave-value">{{data.BL || 0}}</div>
                <div class="leave-name">Birthday Leave</div>
            </div>
        </div>
    </div>
</ng-template> -->


<!-- <ng-template #tooltipContentLeave let-data="data">
    <div class="modern-leave-tooltip">
        <div class="modern-header">
            <span>📊 Leave Balance</span>
        </div>
        <div class="modern-grid">
            <div class="modern-item">
                <span class="modern-label">CL</span>
                <span class="modern-value">{{data?.CL || 0}}</span>
            </div>
            <div class="modern-item">
                <span class="modern-label">SL</span>
                <span class="modern-value">{{data?.SL || 0}}</span>
            </div>
            <div class="modern-item">
                <span class="modern-label">PL</span>
                <span class="modern-value">{{data?.PL || 0}}</span>
            </div>
            <div class="modern-item">
                <span class="modern-label">ML</span>
                <span class="modern-value">{{data?.ML || 0}}</span>
            </div>
            <div class="modern-item">
                <span class="modern-label">PTA</span>
                <span class="modern-value">{{data?.PTA || 0}}</span>
            </div>
            <div class="modern-item">
                <span class="modern-label">BR</span>
                <span class="modern-value">{{data?.BR || 0}}</span>
            </div>
            <div class="modern-item">
                <span class="modern-label">MS</span>
                <span class="modern-value">{{data?.MS || 0}}</span>
            </div>
            <div class="modern-item">
                <span class="modern-label">BL</span>
                <span class="modern-value">{{data?.BL || 0}}</span>
            </div>
        </div>
    </div>
</ng-template> -->

<ng-template #tooltipContentLeave let-data="data">
    <div class="glass-tooltip">
        <div class="glass-title">Consumed leave</div>
        <div class="glass-items">
            <div class="glass-item">
                <span>CL</span>
                <span>{{data?.CL || 0}}</span>
            </div>
            <div class="glass-item">
                <span>SL</span>
                <span>{{data?.SL || 0}}</span>
            </div>
            <div class="glass-item">
                <span>PL</span>
                <span>{{data?.PL || 0}}</span>
            </div>
            <div class="glass-item">
                <span>ML</span>
                <span>{{data?.ML || 0}}</span>
            </div>
            <div class="glass-item">
                <span>PTA</span>
                <span>{{data?.PTA || 0}}</span>
            </div>
            <div class="glass-item">
                <span>BR</span>
                <span>{{data?.BR || 0}}</span>
            </div>
            <div class="glass-item">
                <span>MS</span>
                <span>{{data?.MS || 0}}</span>
            </div>
            <div class="glass-item">
                <span>BL</span>
                <span>{{data?.BL || 0}}</span>
            </div>
        </div>
    </div>
</ng-template>